/* =============================================================================
   MASKHY — navigation
   Transparent over the hero, dark translucent after 80 px. Phone menu sheet with focus
   handling. Smooth in-page jumps that respect reduced motion (never forced scrolling).
   ============================================================================= */
(function () {
  'use strict';

  const nav = document.querySelector('[data-nav]');
  if (!nav) return;
  const toggle = nav.querySelector('[data-nav-toggle]');
  const sheet = document.querySelector('[data-nav-sheet]');
  const reduce = () => !document.documentElement.classList.contains('motion-ok');

  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      nav.classList.toggle('is-scrolled', window.scrollY > 80);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  function setMenu(open) {
    if (!toggle || !sheet) return;
    sheet.hidden = !open;
    nav.classList.toggle('is-menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    const label = toggle.querySelector('[data-nav-toggle-label]');
    if (label) label.textContent = open ? 'Close menu' : 'Open menu';
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      const first = sheet.querySelector('a');
      if (first) first.focus();
    }
  }
  if (toggle) toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && toggle && toggle.getAttribute('aria-expanded') === 'true') {
      setMenu(false);
      toggle.focus();
    }
  });

  // In-page links: #buy, #product… Close the sheet, jump (smoothly unless reduced motion).
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;
    const url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || !url.hash || url.hash === '#') return;
    const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    setMenu(false);
    // Long jumps are instant: nobody should wait for the film to fly past to reach "Buy".
    const y = target.getBoundingClientRect().top + window.scrollY;
    const far = Math.abs(y - window.scrollY) > window.innerHeight * 2.5;
    window.scrollTo({ top: y, behavior: reduce() || far ? 'auto' : 'smooth' });
    history.replaceState(history.state, '', url.hash);
    // move focus for keyboard and screen reader users, without a second jump
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();
